import { render, staticRenderFns } from "./View26.vue?vue&type=template&id=71d8871a&"
import script from "./View26.vue?vue&type=script&lang=js&"
export * from "./View26.vue?vue&type=script&lang=js&"
import style0 from "./View26.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports